/**
 *  @ These are all the app specific constants we will be using:
 */
export const SESSION_STATE = 'SESSION_STATE';
export const SESSION_ID = 'SESSION_ID';
export const USER_DATA = 'USER_DATA';
export const BACKGROUND_EFFECT = 'BACKGROUND_EFFECT';

export const USER_ROLES = [
  {
    label: 'Super Administrator',
    short: 'Super Admin',
    value: 1,
    project: 1,
  },
  {
    label: 'Administrator',
    short: 'Admin',
    value: 2,
    project: 1,
  },
  {
    label: 'General User',
    short: 'General',
    value: 3,
    project: 1,
  },
  {
    label: 'Constituent Staff',
    short: 'Constituent Staff',
    value: 4,
    project: 2,
  },
  {
    label: 'Staff Manager',
    short: 'Manager',
    value: 6,
    project: 2,
  },
  {
    label: 'Member of Provincial Government (MPP)',
    short: 'MPP',
    value: 5,
    project: 2,
  },
  {
    label: 'Member of Parliament (MP)',
    short: 'MP',
    value: 8,
    project: 2,
  },
  {
    label: 'Councillor',
    short: 'Councillor',
    value: 7,
    project: 2,
  },
];

export const DATA_TABLE_HEADER = [
  {
    Header: 'Date',
    accessor: 'date',
    class: 'date-th',
  },
  {
    Header: 'Headline',
    accessor: 'headline',
    class: 'headline-th',
  },
  {
    Header: 'URL',
    accessor: 'url',
    class: 'url-th',
  },
  {
    Header: 'Opening Text',
    accessor: 'opentext',
    class: 'opentext-th',
  },
  {
    Header: 'Hit Sentence',
    accessor: 'hit',
    class: 'hit-th',
  },
];

export const GROUP_TABLE_HEADER = [
  {
    Header: 'Group name',
    accessor: 'name',
    class: 'group-th',
  },
  {
    Header: 'Searches/Topics',
    accessor: 'searches',
    class: 'searches-th',
  },
  {
    Header: 'Users',
    accessor: 'users',
    class: 'users-th',
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    class: 'actions-th',
  },
];

export const USER_TABLE_HEADER = [
  {
    Header: 'First Name',
    accessor: 'firstname',
    class: 'firstname-th',
  },
  {
    Header: 'Last Name',
    accessor: 'lastname',
    class: 'lastname-th',
  },
  {
    Header: 'Email',
    accessor: 'email',
    class: 'email-th',
  },
  {
    Header: 'Role',
    accessor: 'role',
    class: 'role-th',
  },
  {
    Header: 'Searches/Topics',
    accessor: 'searches',
    class: 'searches-th',
  },
  {
    Header: 'Electoral district',
    accessor: 'district',
    class: 'district-th',
  },
  {
    Header: 'MarketPulse',
    accessor: 'marketpulse',
    class: 'marketpulse-th',
  },
];

export const DISTRICT_TABLE_HEADER = [
  {
    Header: 'District',
    accessor: 'name',
    class: 'district-th',
  },
  {
    Header: 'Users',
    accessor: 'users',
    class: 'users-th',
  },
];

export const GOOGLE_TRENDS_TABLE_HEADER = [
  {
    Header: 'Name',
    accessor: 'name',
    class: 'name-th',
  },
  {
    Header: 'Users',
    accessor: 'users',
    class: 'users-th',
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    class: 'actions-th',
  },
];

export const RIDING_TABLE_HEADER = [
  {
    Header: 'Name',
    accessor: 'name',
    class: 'name-th',
  },
  {
    Header: 'Scorecard Widgets',
    accessor: 'widgets',
    class: 'widgets-th',
  },
];

export const IMPORTANCE_TYPES = [
  {
    label: 'Critical',
    value: 3,
  },
  {
    label: 'Urgent',
    value: 2,
  },
  {
    label: 'Normal',
    value: 1,
  },
];

export const PARTIES_COLORS = [
  {
    party: 'PC',
    color: '#1A4782',
  },
  {
    party: 'Liberal',
    color: '#D71920',
  },
  {
    party: 'NDP',
    color: '#F47D20',
  },
  {
    party: 'Green',
    color: '#3D9B35',
  },
  {
    party: 'New Blue',
    color: '#003366',
  },
  {
    party: 'Ontario Party',
    color: '#4B0082',
  },
  {
    party: 'Other',
    color: '#A0A0A0',
  },
  {
    party: 'Libertarian',
    color: '#FFD700',
  },
  {
    party: 'Electoral Reform Party',
    color: '#20B2AA',
  },
  {
    party: 'Independent',
    color: '#CCCCCC',
  },
  {
    party: 'Conservative Party of Canada',
    color: '#0C2C84',
  },
  {
    party: 'Populist Party Ontario',
    color: '#800000',
  },
];

export const PROVINCIAL_RESULTS = [
  {
    name: 'PC',
    percentage: '42.97',
  },
  {
    name: 'Liberal',
    percentage: '29.95',
  },
  {
    name: 'NDP',
    percentage: '18.55',
  },
];
